import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { EditorComponent } from './components/editor/editor.component';
import { ExtendedEditorComponent } from './components/extended-editor/extended-editor.component';
import { UnsaveChangeWarningComponent } from './components/unsave-change-warning/unsave-change-warning.component';
import { RichEditorDirective } from './directives/rich-editor.directive';
import { DictionaryManagerService } from './services/dictionary-manager.service';
import { RichEditorService } from './services/rich-editor.service';
import { SpellcheckWorkerAdapterService } from './services/spellcheck-worker-adapter.service';
import { SpellcheckerService } from './services/spellchecker.service';

@NgModule({
  declarations: [
    EditorComponent,
    UnsaveChangeWarningComponent,
    ExtendedEditorComponent,
    RichEditorDirective,
  ],
  imports: [CommonModule, SharedModule, TranslateDirective, TranslatePipe],
  exports: [EditorComponent, ExtendedEditorComponent],
  providers: [
    RichEditorService,
    SpellcheckerService,
    DictionaryManagerService,
    SpellcheckWorkerAdapterService,
  ],
})
export class RichEditorModule {}
